import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/research/importer/researchImporterActions';

export default importerReducers(actions);
